import React, { useEffect, useState } from 'react';
import { Notebook, NotebookCell } from '../../services/notebook-service/src/types';
import { NotebookCellComponent } from './NotebookCell';
import { NotebookResults } from './NotebookResults';
import { NotebookComments } from './NotebookComments';
// import * as Y from 'yjs'; // For real-time collaboration

interface NotebookInterfaceProps {
  notebookId: string;
  userRole: string;
}

export const NotebookInterface: React.FC<NotebookInterfaceProps> = ({ notebookId, userRole }) => {
  const [notebook, setNotebook] = useState<Notebook | null>(null);
  const [loading, setLoading] = useState(false);
  // const [yDoc, setYDoc] = useState<Y.Doc | null>(null); // For Yjs/CRDT

  useEffect(() => {
    fetchNotebook();
    // TODO: Set up Yjs/CRDT for real-time collaboration
  }, [notebookId]);

  const fetchNotebook = async () => {
    setLoading(true);
    // TODO: Replace with real API call
    const resp = await fetch(`/api/notebooks/${notebookId}`, { headers: { 'x-user-role': userRole } });
    const data = await resp.json();
    setNotebook(data);
    setLoading(false);
  };

  const handleAddCell = async (type: 'sql' | 'nlp' | 'markdown') => {
    // TODO: Replace with real API call
    await fetch(`/api/notebooks/${notebookId}/cells`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-user-role': userRole },
      body: JSON.stringify({ type, content: '' })
    });
    fetchNotebook();
  };

  const handleRunCell = async (cellId: string) => {
    // TODO: Call backend to run cell and update output
    fetchNotebook();
  };

  const handleDeleteCell = async (cellId: string) => {
    // TODO: Replace with real API call
    await fetch(`/api/notebooks/${notebookId}/cells/${cellId}`, {
      method: 'DELETE',
      headers: { 'x-user-role': userRole }
    });
    fetchNotebook();
  };

  if (loading || !notebook) return <div>Loading notebook...</div>;

  return (
    <div className="notebook-interface">
      <h2>{notebook.name}</h2>
      <div className="notebook-controls">
        {userRole === 'editor' && (
          <>
            <button onClick={() => handleAddCell('sql')}>Add SQL Cell</button>
            <button onClick={() => handleAddCell('nlp')}>Add NLP Cell</button>
            <button onClick={() => handleAddCell('markdown')}>Add Markdown Cell</button>
          </>
        )}
        <span>Version: {notebook.version}</span>
      </div>
      <div className="notebook-cells">
        {notebook?.cells?.map(cell => (
          <NotebookCellComponent
            key={cell.id}
            cell={cell}
            userRole={userRole}
            onRun={() => handleRunCell(cell.id)}
            onDelete={() => handleDeleteCell(cell.id)}
          />
        ))}
      </div>
      <NotebookResults notebook={notebook} />
      <NotebookComments notebookId={notebookId} />
    </div>
  );
};